import React, { useEffect, useState } from 'react';
import useSOCopilotAdminPrompts from '../hooks/useSOCopilotAdmin';
import { FaCheck, FaHourglassHalf } from "react-icons/fa6";

const SubscriptionPlans = (/*{ plans }*/) => {

    const LEXIA_EXTENSION_ID = (window as any).env.REACT_APP_LEXIA_EXTENSION_ID;
    
    const [extensionId, setExtensionId] = useState<string>(LEXIA_EXTENSION_ID);
    const { plans, planUpdating, createOrUpdatePlan } = useSOCopilotAdminPrompts(null, null, extensionId);

    const [queryValues, setQueryValues] = useState(
        plans.map((plan) => plan.socOpenAiSubscriptionPlan?.queryAllowed)
    );

    const handleQueryChange = (index, value) => {
        const newQueryValues = [...queryValues];
        newQueryValues[index] = +value;
        setQueryValues(newQueryValues);
    };

    const handleCreateOrUpdatePlan = async (p0: {
        index: number;
        id: any;
        code: string;
        name: string;
        gptDeploymentName: string;
        maxOutputTokensAllowedByQuery: number;
    }) => {
        await createOrUpdatePlan({
            id: p0.id,
            code: p0.code,
            name: p0.name,
            tokenAllowed: 1000,
            queryAllowed: queryValues[p0.index],
            gptDeploymentName: p0.gptDeploymentName,
            maxOutputTokensAllowedByQuery: p0.maxOutputTokensAllowedByQuery,
        });
    };

    useEffect(() => {
        setQueryValues(plans.map((plan) => plan.socOpenAiSubscriptionPlan?.queryAllowed));
    }, [plans]);

    return (
        <div className="section" style={{ fontSize: "15px" }}>
            <div className="container">
                {/* <h2 className="title is-4 has-text-centered">Subscription Plans</h2> */}

                {plans.length > 0 ? (
                    <div className="table-container">
                        <table className="table is-striped is-hoverable is-fullwidth">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Code</th>
                                    <th>Number of Queries</th>
                                    <th>Monthly Price</th>
                                    <th>Yearly Price</th>
                                    <th>Max Users</th>
                                    <th>State</th>
                                    <th>Additional Applications</th>
                                </tr>
                            </thead>
                            <tbody>
                                {plans.map((plan, index) => (
                                    <tr key={plan.enhanseSubscriptionPlan.id}>
                                        <td>{plan.enhanseSubscriptionPlan.name}</td>
                                        <td>{plan.enhanseSubscriptionPlan.code}</td>
                                        <td style={{ height: '100%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '0.5rem', height: '100%' }}>
                                                <input
                                                    disabled={planUpdating.idPlan === plan.enhanseSubscriptionPlan.id && planUpdating.isUpdating}
                                                    className="input is-large"
                                                    type="number"
                                                    placeholder="Enter queries"
                                                    value={queryValues[index]}
                                                    onChange={(e) =>
                                                        handleQueryChange(index, e.target.value)
                                                    }
                                                />
                                                <button
                                                    className="button is-small is-success ml-2"
                                                    style={{ padding: '0.25rem 0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                    onClick={() => handleCreateOrUpdatePlan({
                                                        id: plan.enhanseSubscriptionPlan.id,
                                                        code: plan.enhanseSubscriptionPlan.code,
                                                        name: plan.enhanseSubscriptionPlan.name,
                                                        gptDeploymentName: 'gpt-4o',
                                                        maxOutputTokensAllowedByQuery: 1000,
                                                        index: index
                                                    })}
                                                >
                                                    {
                                                        !(planUpdating.idPlan === plan.enhanseSubscriptionPlan.id && planUpdating.isUpdating) &&
                                                        <FaCheck />
                                                    }
                                                    {
                                                        planUpdating.idPlan === plan.enhanseSubscriptionPlan.id && planUpdating.isUpdating &&
                                                        <FaHourglassHalf />
                                                    }
                                                </button>
                                            </div>
                                        </td>
                                        <td>{plan.enhanseSubscriptionPlan.monthlyPrice.toFixed(2)} €</td>
                                        <td>{plan.enhanseSubscriptionPlan.yearlyPrice.toFixed(2)} €</td>
                                        <td>
                                            {plan.enhanseSubscriptionPlan.allowsUnlimitedUsers
                                                ? "Unlimited"
                                                : plan.enhanseSubscriptionPlan.maxNumberOfUsers || "N/A"}
                                        </td>
                                        <td>{plan.enhanseSubscriptionPlan.state}</td>
                                        <td>
                                            {plan.enhanseSubscriptionPlan.additionalApplications.length > 0 ? (
                                                <ul>
                                                    {plan.enhanseSubscriptionPlan.additionalApplications.map((app) => (
                                                        <li key={app.id}>{app.name}</li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                "None"
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="has-text-centered has-text-grey-light">No plans available</p>
                )}
            </div>
        </div>
    );
};

export default SubscriptionPlans;
